export const MOCK = {
  heute: "Freitag, 6. November 2026",
  nutzer: "Teamleitung Grefrath",
  kpis: [["Offene Aufgaben", "7"], ["Termine heute", "3"], ["Dringende Hinweise", "2"], ["Aktive Kunden", "48"]],
  aufgaben: [
    { t: "Werbewoche Grefrath: Standortanalyse prüfen", z: "heute", s: "offen", q: "Werbung" },
    { t: "Personalakte Jana Berger: Führungszeugnis nachhalten", z: "heute", s: "dringend", q: "Personal" },
    { t: "Kundenanruf Fam. Hölscher (Wiedervorlage)", z: "heute", s: "offen", q: "Kunden" },
    { t: "Leistungsnachweise Oktober hochladen", z: "morgen", s: "in_bearbeitung", q: "Controlling" },
    { t: "Flyertour Oedt-Süd abschließen", z: "Mo 09.11.", s: "offen", q: "Werbung" },
  ],
  termine: [
    { z: "09:00", t: "Erstgespräch Fam. Terhorst", o: "Grefrath, Hochstr." },
    { z: "11:30", t: "Bewerbungsgespräch Max Vogel", o: "Büro Grefrath" },
    { z: "14:00", t: "Arbeitsschutz-Praxisteil Team Kempen", o: "Kempen" },
    { z: "Mo 08:30", t: "Teamrunde Rheinberg (Vorbereitung Eröffnung)", o: "Videokonferenz" },
  ],
  hinweise: [
    { t: "2 Einstellungsunterlagen ohne Rücklauf seit 14 Tagen", d: "Personalakten › Jana Berger, Tom Schulte", s: "dringend" },
    { t: "Lohnvorbereitung Oktober noch nicht freigegeben", d: "Controlling › Monatsabschluss", s: "in_bearbeitung" },
    { t: "3 Kunden ohne Gespräch seit > 3 Monaten", d: "Kundenanrufliste › Wiedervorlagen", s: "offen" },
  ],
  mitarbeiter: [
    { n: "Jana Berger", st: "Grefrath", art: "Minijob", dok: 4, von: 7, frist: "Führungszeugnis bis 12.11.", s: "dringend" },
    { n: "Tom Schulte", st: "Grefrath", art: "Teilzeit", dok: 5, von: 8, frist: "Rücklauf Vertrag offen", s: "in_bearbeitung" },
    { n: "Maria Kempers", st: "Kempen", art: "Teilzeit", dok: 8, von: 8, frist: "", s: "erledigt" },
    { n: "Lutz Hendricks", st: "Viersen", art: "Minijob", dok: 7, von: 7, frist: "", s: "erledigt" },
    { n: "Ayşe Demir", st: "Kempen", art: "Minijob", dok: 3, von: 7, frist: "Arbeitsschutz-Praxis bis 20.11.", s: "in_bearbeitung" },
    { n: "Peter Nowak", st: "Rheinberg", art: "Teilzeit", dok: 1, von: 8, frist: "Einstellungspaket erstellen", s: "offen" },
  ],
  orte: [
    { n: "Rosen-Apotheke", k: "Apotheke", e: "350 m", p: 5, s: "neu", emp: "Pflegeberatung · Flyer vorbeibringen" },
    { n: "Hausarztpraxis Dr. Vollmer", k: "Arztpraxis", e: "600 m", p: 5, s: "geeignet", emp: "Alltagsbegleitung · Gespräch mit Leitung" },
    { n: "Seniorentreff St. Laurentius", k: "Seniorenangebot", e: "900 m", p: 4, s: "kontakt", emp: "Hausnotruf · Infotermin anbieten" },
    { n: "Bäckerei Hüskens", k: "Bäckerei", e: "1,1 km", p: 3, s: "auslageort", emp: "Flyerauslage bestätigt" },
    { n: "Physiotherapie Mobilis", k: "Therapie", e: "1,4 km", p: 4, s: "neu", emp: "Badumbau-Beratung · Kontaktdaten" },
    { n: "Edeka Oedt", k: "Supermarkt", e: "1,6 km", p: 2, s: "wiedervorlage", emp: "Wiedervorlage 15.01.2027" },
    { n: "Kath. Pfarrbüro", k: "Kirche/Verein", e: "1,9 km", p: 3, s: "neu", emp: "Pflegeberatung · Gemeindebrief" },
  ],
  touren: [{ n: "Oedt-Süd", st: "unterbrochen", e: 4, g: 7, next: "Bäckerei Hüskens" }, { n: "Grefrath Zentrum", st: "geplant", e: 0, g: 6, next: "Rosen-Apotheke" }],
};

export const ORT_STATUS = { neu: ["Neu", "offen"], geeignet: ["Geeignet", "in_bearbeitung"], kontakt: ["Kontakt", "in_bearbeitung"], auslageort: ["Auslageort", "erledigt"], wiedervorlage: ["Wiedervorlage", "offen"] };
export const STATUS_LABEL = { offen: "Offen", dringend: "Dringend", in_bearbeitung: "In Bearbeitung", erledigt: "Erledigt" };
